// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sze4","col":"styles_col__qRXZ0"};